var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useState } from 'react';
export const useLogoutFlow = () => {
    _react_refresh_temp_1();
    const [isLogoutFlowInProgress, setIsLogoutFlowInProgress] = useState(false);
    return { isLogoutFlowInProgress, setIsLogoutFlowInProgress };
};
_react_refresh_temp_1(useLogoutFlow, "vLDIWjVg6CC3VOmu2iB0cFmxLIg=");
